import { gql } from '@apollo/client';

export const paymentDelayGql = gql`
  query PaymentDelay(
    $invoiceNumber: Int!
    $personId: Int!
    $invoiceSerieDescription: String!
    $invoiceSubSerieNumber: Int!
    $issueDate: String!
  ) {
    paymentDelay(
      invoiceNumber: $invoiceNumber
      personId: $personId
      invoiceSerieDescription: $invoiceSerieDescription
      invoiceSubSerieNumber: $invoiceSubSerieNumber
      issueDate: $issueDate
    ) {
      amountNet
      delayPaymentTerm
      orderNumber
      originalScheduleDate
      productId
      productName
      proportionalDelayTerm
    }
  }
`;
